import './LacksOverview.css';

import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LackDetails } from '../../LacksInput/LacksInput';

import {
	Button,
	Grid,
	Stack,
	Paper,
	Typography,
} from '@mui/material';

import {
	Delete,
} from '@mui/icons-material';

function LacksOverview({ groups, errorElements }) {
	const { t } = useSelector((redux) => redux.store);
	const [groupedPartsWithLacks, setGroupedPartsWithLacks] = useState(getGroupedPartsWithLacks(groups));

	return (
		<Grid
			container
			className="lacks-overview__main">
			{ groupedPartsWithLacks.length > 0 && groupedPartsWithLacks.map((group, index) => (
				<Stack key={index}>
					<h1>
						{ group.name }
					</h1>
					{ group.parts.length > 0 && group.parts.map((part, index) => (
						<Part
							key={ index }
							part={ part }
							errorElements={errorElements}
							onChange={ rebuildOverview } />
					))}
				</Stack>
			))}
			{ groupedPartsWithLacks.length === 0 &&
				<Stack>
					<Typography
						variant="subtitle1"
						sx={{ marginBottom: 2 }}
					>
						{ t.lack_overview_empty || 't.lack_overview_empty' }
					</Typography>
				</Stack>
			}
		</Grid>
	);

	/**
	 * Filter out the groups and parts that don’t have lacks
	 *
	 * @todo move elsehwere, inside component, or whatevs
	 *
	 * @param  {Object} groups
	 * @return {Array}
	 */
	function getGroupedPartsWithLacks(groups) {
		return Object.values(groups).reduce((collection, group) => {
			const partsWithLacks = group.parts.filter((part) => part.lacks.length);
			if (partsWithLacks.length) {
				collection.push({
					name: group.name, parts: partsWithLacks,
				});
			}
			return collection;
		}, []);
	}

	/**
	 * Trigger a rerender
	 */
	function rebuildOverview() {
		setGroupedPartsWithLacks(getGroupedPartsWithLacks(groups));
	}
}

function Part({ part, onChange, errorElements }) {
	const [lacks, setLacks] = useState(part.lacks);

	useEffect(() => {
		onChange();
	}, [lacks]);

	/**
	 * @todo Refactor into Lack component
	 * Could use lack[oldLackIndex] = newLack; and then useEffect to update the old object, like in inspectionPart?
	 */
	function onChangeLack(newLack, part, oldLackIndex) {
		part.lacks[oldLackIndex] = newLack;
		setLacks([...part.lacks]); // use spread operator to trigger rerender; changing only properties of an object in an array won't rerender
	}

	/**
     * @todo Refactor into Lack component
	 */
	function handleDelete(lack, part) {
		let newLacks;
		if (lack.id) {
			lack.delete_me = true;
			newLacks = [ ...part.lacks ];
		} else {
			const partIndex = part.lacks.indexOf(lack);
			newLacks = [ ...part.lacks ];
			newLacks.splice(partIndex, 1);
		}
		part.lacks = newLacks;
		setLacks(part.lacks);
	}

	return (
		<Paper
			variant="outlined"
			elevation={0}
			className="lacks-overview__group"
		>
			<Typography
				variant="h6"
				component="h3"
			>
				{part.name}
			</Typography>
			{ lacks.length > 0 && lacks.map((lack, index) => (
				<Lack
					key={index}
					part={part}
					lack={lack}
					errorElements={errorElements}
					onChange={onChangeLack}
					onDelete={handleDelete}
				/>
			))}
		</Paper>
	);
}

function Lack({ part, lack, onChange, onDelete, errorElements }) {
	const { t, knownLacks } = useSelector(redux => redux.store);
	lack.selectedLack = knownLacks.find((knownLack) => knownLack.id === lack.selected_lack_id) || {};
	const index = part.lacks.indexOf(lack);

	return (
		<Paper
			className={`lacks-overview__lack ${ lack.delete_me && 'lacks-overview__lack--deleted' }`}
			elevation={0}>
			<Button
				className="button-delete"
				variant='outlined'
				color="error"
				disabled={lack.delete_me}
				onClick={ () => confirm(t.lack_delete_confirm || 't.lack_delete_confirm') && onDelete(lack, part)}
			>
				<Delete/>
			</Button>
			<Typography
				variant="h6"
				component="h4"
			>
				{getTitle()}
			</Typography>
			{ lack.delete_me &&
				<Typography
					variant="subtitle1">
					{t.lack_to_be_deleted || 't.lack_to_be_deleted'}
				</Typography>
			}
			<LackDetails
				id={`part_${part.id}_lack_${index}`}
				lack={lack}
				validate={true}
				errorElements={errorElements}
				onChangeLack={ (newLack) => onChange(newLack, part, index) }
			/>
		</Paper>
	);

	/**
	 * Get title for form dialog, in- or excluding code
	 *
	 * @todo this is a duplicate of the same code in LacksInput. Not sure where
	 * to put it to keep it DRY
	 *
	 * @return {String}
	 */
	function getTitle() {
		return lack.code || lack.selectedLack?.code
			? `${lack.code || lack.selectedLack?.code}: ${lack.title || lack.selectedLack?.title}`
			: lack.title || lack.selectedLack?.title;
	}
}

export default LacksOverview;
